import { render } from "./CategoryPill.vue?vue&type=template&id=efbf7218&ts=true"
import script from "./CategoryPill.vue?vue&type=script&lang=ts"
export * from "./CategoryPill.vue?vue&type=script&lang=ts"

import exportComponent from "/home/issa/hcpet/hcpet-kasse/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__